import { Controller } from "@hotwired/stimulus"

// Menú hamburguesa del navbar V2. El abrir/cerrar lo hace <details> nativo
// (funciona sin JS y sobrevive a Turbo); este controller solo agrega lo que el
// elemento nativo no trae: cerrar al hacer click fuera y cerrar con Escape.
export default class extends Controller {
  closeOnOutsideClick(event) {
    if (!this.element.open) return
    if (this.element.contains(event.target)) return
    this.element.open = false
  }

  // Escape cierra el menú y NADA más: se consume (stopPropagation) para que
  // un modal que también escucha Escape (v2--modal, en document) no se cierre
  // con el mismo golpe cuando el menú vive adentro. El caller lo cuelga en
  // fase de captura (`keydown@window->v2--menu#closeOnEscape:capture`) si
  // hay un modal debajo; en el navbar da igual.
  closeOnEscape(event) {
    if (event.key !== "Escape" || !this.element.open) return
    event.stopPropagation()
    this.element.open = false
    this.element.querySelector("summary")?.focus()
  }

  // Cierre explícito (un item elegido): sin esto un <details> queda abierto
  // después de que su link navegó un frame ajeno.
  close() {
    this.element.open = false
  }
}
